import React from "react";
import { Link, Outlet } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import "./creativePortfolio.css";

export default function CreativeLayout() {
  return (
    <div className="creative-shell">
      <a className="creative-skip-link" href="#portfolio-main">Skip to content</a>
      <header className="creative-header">
        <Link to="/mycreative" className="creative-wordmark" aria-label="Terik Atwell portfolio home">
          <span>TA</span>
          <div><strong>Terik Atwell</strong><small>Creative Director</small></div>
        </Link>
        <a className="creative-contact-link" href="mailto:sales@metistechlabs.com">
          Start a conversation <ArrowUpRight size={17} aria-hidden="true" />
        </a>
      </header>
      <main id="portfolio-main"><Outlet /></main>
      <footer className="creative-footer">
        <p>Terik Atwell · Creative direction, websites, and practical business systems.</p>
        <a href="mailto:sales@metistechlabs.com">sales@metistechlabs.com</a>
      </footer>
    </div>
  );
}
